<template>
  <DsProcessSection
    title=""
    title-id="hazte-duena-process-title"
    intro="Sigue estos 5 pasos para avanzar hacia tu nueva casa."
    layout="grid"
    :columns="3"
    card-variant="stacked"
    :steps="steps"
  >
    <template #title>¿Cómo es <span>el</span> <span class="hl">proceso</span><span>?</span></template>
    <template #step-1
      ><p>Evaluaremos tu historial, capacidad de pago y endeudamiento mediante:</p>
      <p>• Buró de crédito • Comprobantes de ingresos</p>
      <p>Esto nos permite identificar la mejor alternativa para tu proceso.</p></template
    >
    <template #step-2
      ><p>
        Nos aseguramos de que tu patrimonio cuente con respaldo físico y jurídico, mediante la revisión integral del
        inmueble, validando su situación legal, características físicas, ubicación, disponibilidad de servicios y
        viabilidad para su correcta escrituración.
      </p></template
    >
    <template #step-3
      ><p>
        Deberás compartir la documentación requerida (INE y comprobantes de tus ingresos) para completar tu expediente y
        continuar con la validación de tu operación.
      </p></template
    >
    <template #step-4
      ><p>Tu operación pasa por un comité de validación para asegurar que cumple con los requisitos.</p></template
    >
    <template #step-5
      ><p>
        Una vez que todo esté validado, las cifras cerradas y se cumplan los requisitos de adjudicación: Firmamos la
        escritura y ¡te entregamos tu propiedad!
      </p></template
    >
  </DsProcessSection>
</template>
<script setup lang="ts">
import DsProcessSection from '../components/DsProcessSection.vue'
const steps = [
  {
    id: '1',
    title: 'Revisión crediticia'
  },
  {
    id: '2',
    title: 'Validación del inmueble'
  },
  {
    id: '3',
    title: 'Documentación'
  },
  {
    id: '4',
    title: 'Aprobación',
    wide: true
  },
  {
    id: '5',
    title: 'Escrituración',
    wide: true
  }
]
</script>
